import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';

var Badge = /*#__PURE__*/function (_PureComponent) {
  _inherits(Badge, _PureComponent);

  var _super = _createSuper(Badge);

  function Badge() {
    _classCallCheck(this, Badge);

    return _super.apply(this, arguments);
  }

  _createClass(Badge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          children = _this$props.children,
          outline = _this$props.outline,
          dot = _this$props.dot,
          color = _this$props.color,
          count = _this$props.count,
          icon = _this$props.icon,
          offset = _this$props.offset;
      var customStyle = {
        borderColor: outline && color,
        color: outline && color,
        backgroundColor: !outline && color,
        marginTop: offset === null || offset === void 0 ? void 0 : offset[0],
        right: offset !== null && offset !== void 0 && offset[1] ? -offset[1] : undefined
      };
      var hidePadding = icon || count < 10 || _typeof(count) === 'object';
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: classNames('jmtd-badge', className, {
          'jmtd-badge-icon': !!icon,
          'jmtd-badge-no-icon': !icon,
          'jmtd-badge-outline': !icon && outline,
          'jmtd-badge-dot': !icon && dot,
          'jmtd-badge-padding': !hidePadding,
          'jmtd-badge-not-wrapper': !children
        })
      }, children, /*#__PURE__*/React.createElement("sup", {
        className: "jmtd-badge-sup",
        style: customStyle
      }, icon, !icon && !dot && /*#__PURE__*/React.createElement("span", {
        className: "jmtd-badge-sup-value"
      }, count)));
    }
  }]);

  return Badge;
}(PureComponent);

Badge.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  outline: PropTypes.bool,
  dot: PropTypes.bool,
  color: PropTypes.string,
  count: PropTypes.any,
  icon: PropTypes.node,
  offset: PropTypes.array
};
Badge.defaultProps = {
  children: null,
  id: null,
  className: '',
  outline: false,
  dot: false,
  color: '',
  count: null,
  icon: null,
  offset: []
};
export default Badge;